import React from 'react';
import renderHTML from 'react-render-html';
import { Divider } from 'telstra-ui/components/divider/Divider';
import { formatNumber } from '../../../../app-actions';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import './device-leasing-section.css';

const DeviceLeasingSection = (props) => {
  const {
    authorableContent: {
      deviceLeasingDescription,
      tradeInDeviceCountText,
      serviceIphoneLeaseCount,
      motifText,
      averageAFSValue,
      effectiveMoorupServiceText,
      phoneCostText,
      averageCostHeading,
      totalCostHeadingPre,
      totalCostHeadingPost,
      totalSavingText,
      rrpCostText,
      reductionInCostText,
    },
    motifValue,
    totalAMPlanDevices,
    averageAfsValue,
    moorUpServiceValue,
    avgPhoneCost,
    tradeInDeviceCount,
    newDeviceCount,
    currentMontlyCost,
    newMontlyCost,
    contractTerm,
    rrpCostValue,
  } = props;

  return (
    <React.Fragment>
      <div className="device-leasing-section-main row">
        <div className="leasing-desciption">{renderHTML(stripStartingAndEndingPTags(deviceLeasingDescription))}</div>
      </div>
      <Divider className={'tl-dark-grey row'} />
      <div className="device-leasing-section-calculated">
        <div className="row header-row">
          <div className="col-8">
            {tradeInDeviceCountText}
          </div>
          <div className="col-4 calculated-data">
            {tradeInDeviceCount}
          </div>
        </div>
        <Divider className="tl-custom-grey" />
        <div className="row">
          <div className="col-8">
            {serviceIphoneLeaseCount}
          </div>
          <div className="col-4 calculated-data">
            {newDeviceCount}
          </div>
        </div>
        <div className="row calculate-row-header">
          <div className="offset-md-6 col-2 data-col">
            {renderHTML(averageCostHeading)}
          </div>
          <div className="offset-md-2 col-2 data-col">
            {renderHTML(`${totalCostHeadingPre} ${contractTerm} ${totalCostHeadingPost}`)}
          </div>
        </div>
        <div className="row data-row">
          <div className="col-4">
            {averageAFSValue}
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber(averageAfsValue, 2)}</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber(averageAfsValue * contractTerm * newDeviceCount, 2)}</div>
          </div>
        </div>
        <Divider className="tl-custom-grey no-space" />
        <div className="row data-row">
          <div className="col-4">
            {effectiveMoorupServiceText}
          </div>
          <div className="col-4">
            <div className="calculated-data">-${formatNumber(moorUpServiceValue, 2)}</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">-${formatNumber(moorUpServiceValue * contractTerm * newDeviceCount, 2)}</div>
          </div>
        </div>
        <Divider className="tl-custom-grey no-space" />
        <div className="row data-row">
          <div className="col-4">
            {motifText}
          </div>
          <div className="col-4">
            <div className="calculated-data">-${formatNumber(motifValue, 2)}</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">-${formatNumber(motifValue * contractTerm * totalAMPlanDevices, 2)}</div>
          </div>
        </div>
        <Divider className="tl-custom-grey no-space" />
        <div className="row data-row special-footer-border">
          <div className="col-4">
            {phoneCostText}
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber(avgPhoneCost, 2)}</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber(avgPhoneCost * contractTerm * newDeviceCount, 2)}</div>
          </div>
        </div>
        <Divider className="tl-custom-grey no-space" />
        <div className="row data-row cost-row">
          <div className="col-6">
            {rrpCostText}
          </div>
          <div className="col-2">
            <div className="calculated-data">&nbsp;</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber((currentMontlyCost * contractTerm)
              + (rrpCostValue * contractTerm * newDeviceCount), 2)}</div>
          </div>
        </div>
        <Divider className="tl-custom-grey no-space" />
        <div className="row data-row cost-row">
          <div className="col-6">
            {totalSavingText}
          </div>
          <div className="col-2">
            <div className="calculated-data">&nbsp;</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber((newMontlyCost * contractTerm)
              + (avgPhoneCost * contractTerm * newDeviceCount), 2)}</div>
          </div>
        </div>

        <div className="row calculate-row-footer">
          <div className="col-6">
            {reductionInCostText}
          </div>
          <div className="col-2">
            <div className="calculated-data">&nbsp;</div>
          </div>
          <div className="col-4">
            <div className="calculated-data">${formatNumber(((currentMontlyCost * contractTerm)
              + (rrpCostValue * contractTerm * newDeviceCount)) - ((newMontlyCost * contractTerm)
                + (avgPhoneCost * contractTerm * newDeviceCount)), 2)}</div>
          </div>
        </div>

      </div>
    </React.Fragment>
  );
};

export default DeviceLeasingSection;
